import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { errorTranslations } from '@jaam/commons/exceptions';

export type I18nOptions = {
  localEn?: object;
  localFr?: object;
  defaultNamespace?: string;
  lng?: string;
};

export function initI18n({
  localEn = {},
  localFr = {},
  defaultNamespace = 'translation',
  lng = 'fr',
}: I18nOptions = {}) {
  const mergedEn = { ...errorTranslations.en, ...localEn };
  const mergedFr = { ...errorTranslations.fr, ...localFr };

  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources: {
        en: { [defaultNamespace]: mergedEn },
        fr: { [defaultNamespace]: mergedFr },
      },
      ns: [defaultNamespace],
      defaultNS: defaultNamespace,
      keySeparator: '.',
      interpolation: {
        escapeValue: false,
      },
      lng,
      react: {
        useSuspense: false,
      },
    });

  return i18n;
}

export const t = (key: string | string[], options?: any) =>
  i18n.t(key, options);
